export enum Language {
  EN = "en",
  NL = "nl",
  RO = "ro",
}
